import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useCart } from "@/lib/store";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX = 8;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | timeout | error
  const { clear } = useCart();
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= MAX) {
        setStatus("timeout");
        return;
      }
      attempts += 1;
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) {
            clear();
            cleared.current = true;
          }
          return;
        }
      } catch (e) {
        setStatus("error");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, clear]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[var(--bg)]">
      <div className="text-center max-w-lg">
        {status === "checking" && (
          <>
            <Loader2 className="w-14 h-14 animate-spin mx-auto text-[var(--accent)] mb-8" />
            <h1 className="font-anton uppercase text-4xl md:text-5xl tracking-tighter">
              Confirming payment
            </h1>
            <p className="text-[var(--text-dim)] mt-4">Hang tight, this only takes a moment.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto text-[var(--accent)] mb-8" />
            <h1 className="font-anton uppercase text-5xl md:text-6xl tracking-tighter">
              You're in.
            </h1>
            <p className="text-[var(--text-dim)] mt-4">
              Payment confirmed. Your FULL SEND tee is on the way — we'll be in touch on delivery.
            </p>
            <Link
              to="/"
              data-testid="back-home-btn"
              className="inline-block mt-10 bg-[var(--text)] text-black px-8 py-4 uppercase tracking-widest text-sm font-bold hover:bg-[var(--accent)] hover:text-white transition-colors"
            >
              Back to store
            </Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <XCircle className="w-16 h-16 mx-auto text-[var(--text-dim)] mb-8" />
            <h1 className="font-anton uppercase text-4xl md:text-5xl tracking-tighter">
              Still processing
            </h1>
            <p className="text-[var(--text-dim)] mt-4">
              We couldn't confirm your payment yet. If you were charged, contact us and we'll sort it.
            </p>
            <Link
              to="/"
              className="inline-block mt-10 border border-[var(--line)] px-8 py-4 uppercase tracking-widest text-sm font-bold hover:border-white transition-colors"
            >
              Back to store
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
